<template>
  <div class="header">
    <BfProgress
      class="progress-bar"
      :steps="steps"
      :current-step="getStep"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { BfProgress } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useProgressStore } from '@/store/progressStore'
import { ProgressStep } from '@finetic/bikefitting-ui/dist/types/progressTypes'

const { t } = useI18n()

const progressStore = useProgressStore()
const { getStep } = storeToRefs(progressStore)

const steps = computed<ProgressStep[]>(() => [
  { title: t('steps.start') },
  { title: t('steps.setup') },
  { title: t('steps.analysis') },
  { title: t('steps.data') },
  { title: t('steps.completion') },
])
</script>

<style lang="scss">
.header {
  width: 100%;
  padding: 1rem 0;
}
</style>
